const MAX_PLAY = 15
const DELAY = 1000
const audio = new Audio('/static/notification.mp3')

export default {
  data () {
    return {
      notificationCount: 0,
      timeout: null
    }
  },
  methods: {
    clear () {
      audio.pause()
      audio.currentTime = 0
      clearTimeout(this.timeout)
      this.notificationCount = 0
    },
    async playNotification () {
      audio.pause()
      audio.currentTime = 0
      try {
        await audio.play()
      } catch (e) {}
      if (this.notificationCount < MAX_PLAY) {
        this.notificationCount++
        this.timeout = setTimeout(() => this.playNotification(), DELAY)
      } else {
        this.clear()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/soundNotification.js